import { isNil } from 'lodash';
import { ImageStyle } from 'react-native';
import { IconAvatar } from '@shared/components/Icon';
import { MBView } from '@shared/components/MBView';
import { Colors } from '@shared/styles';
import { API } from '@shared/types/api';
import { MBImage } from './MBImage';
import { Styles } from './styles';

interface MBBusinessImageProps {
  business?: API.BusinessFragment;
  /** Diameter in px. Without it the image is 48px with a faint border. */
  size?: number;
}

const colors = Colors.v2.avatar.business;
const DEFAULT_SIZE = 48;

export function MBBusinessImage({ business, size }: MBBusinessImageProps) {
  const imageStyle: ImageStyle = isNil(size)
    ? Styles.channelImage
    : { width: size, height: size, borderRadius: size / 2, overflow: 'hidden' };

  if (!business) {
    return <MBView style={[imageStyle, { backgroundColor: Colors.v2.gray10 }]} />;
  }

  if (!!business.img) {
    return (
      <MBImage style={[imageStyle, { backgroundColor: 'white' }]} source={{ uri: business.img }} />
    );
  }
  return (
    <IconAvatar
      name="storefront"
      size={size ?? DEFAULT_SIZE}
      color="white"
      backgroundColor={colors[business.id % colors.length]}
    />
  );
}
